import gql from 'graphql-tag';

export const ARCHIVE_LOCATION_SECTOR_MUTATION = gql`
  mutation ArchiveLocationSector($input: ArchiveLocationSectorInput!) {
    archiveLocationSector (input: $input) {
      id
    }
  }
`;


export const UNARCHIVE_LOCATION_SECTOR_MUTATION = gql`
  mutation UnarchiveLocationSector($input: UnarchiveLocationSectorInput!) {
    unarchiveLocationSector (input: $input) {
      id
    }
  }
`;
